module.exports = __webpack_public_path__ + "img/3.3a047a85.jpg";